<script lang="ts" setup>
import { computed } from 'vue'
import LoadingSpin from '~common/loading-spin.vue'
import BaseButton from '~common/base-button.vue'
import { useInstruction } from '~composables/promotion/use-promotion-static'
import { useUserData } from '~/composables/account/use-user-data'
import { AccountTabs } from '~/constants/account'
import { PROMOTION_SLUG_BY_TYPE } from '~/constants'

const {
  promotionBanners,
  currentIndex,
  isShowDetaiPromotion,
  loading,
  promotionDetail,
  getPromotion
} = useInstruction()
const { currentUser } = useUserData()
const packageId = computed(() => {
  return currentUser.value?.package_id
})
</script>
<template>
  <div class="promotion">
    <div v-if="!isShowDetaiPromotion">
      <div v-if="promotionBanners.length && !loading" class="promotion__list-promotion">
        <div v-for="(item, index) in promotionBanners" :key="index" class="item-promotion">
          <img class="img-promotion" :src="item.thumbnailUrlMb" :alt="item.title" />
          <div class="ctn-content">
            <div class="text-title">{{ item.title }}</div>
            <div class="text-subtitle">{{ item.subTitle }}</div>
          </div>
  
          <ClientOnly>
            <div class="ctn-btn-promotion">
              <NuxtLink class="btn-promotion btn-detail" :to="`${AccountTabs.PROMOTION}?tab=${item.slug}`">
                Xem chi tiết
              </NuxtLink>
  
              <BaseButton v-if="packageId === item.packageId" size="small" disable>
                Đã sử dụng
              </BaseButton>
              <div v-else class="btn-promotion btn-receive-now" @click="getPromotion(index)">Nhận ngay</div>
            </div>
          </ClientOnly>
        </div>
      </div>
    </div>

    <div v-else class="promotion__content-detail">
      <a
        v-if="promotionBanners[currentIndex].packageName === PROMOTION_SLUG_BY_TYPE.DUA_TOP_THE_THAO"
        class="promotion__content-detail__event-link"
        @click="getPromotion()"
      >
        <span></span>Xem danh sách xếp hạng
      </a>

      <LoadingSpin v-if="loading" />

      <template v-else>
        <div v-if="promotionDetail" class="promotion__content-detail--txt" v-html="promotionDetail"></div>

        <div class="footer-promotion button-fixed-bottom">
          <div class="ctn-content-detail">
            <div class="ctn-content-detail__left">
              <div class="info">
                <span class="info__icon"></span>
                <span class="info__desc">
                  {{ promotionBanners[currentIndex]?.footer.text}}
                  <strong>{{ promotionBanners[currentIndex]?.footer.highlight }}</strong>
                </span>
              </div>
            </div>

            <div class="ctn-content-detail__right">
              <ClientOnly>
                <BaseButton v-if="packageId === promotionBanners[currentIndex]?.packageId" disable>
                  Đã sử dụng
                </BaseButton>
                <BaseButton v-else @click="getPromotion()">
                  {{ promotionBanners[currentIndex]?.footer.button?.text ?? 'Nhận khuyến mãi'}}
                </BaseButton>
              </ClientOnly>
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<style scoped lang="scss">
@import '~scssAsset/mobile/pages/promotion/index.scss';
</style>
